/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const compareFields = (a, b, fields) => {
  for (let i = 0; i < fields.length; i++) {
    for (let j = 0; j < fields.length; j++) {
      if (!a[fields[i]] || !b[fields[j]]) {
        continue;
      }
      if (a[fields[i]] === b[fields[j]]) {
        return true;
      }
      if (+a[fields[i]] === +b[fields[j]]) {
        return true;
      }
    }
  }

  return false;
};

export default compareFields;
